module.exports = __webpack_public_path__ + "static/media/intelbras-brand.90049999.svg";